// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"314cb1a9","875":"ae5d450b","968":"26557a10"}[chunkId] + ".chunk.js";
};